function getEnv() {
  const defaultEnv = {
    endpoint: '/api',
    google_maps_api_key: 'AIzaSyB4D368ZY3mKadgUjyx1j1UF0fg5iegOMk',
    covie_secret: 'ik_wptfwx6htbaob7gd',
    graphql_server: 'http://localhost:3000/api/graphql',
    ren_env: 'development',
    segment_api_key: null,
  };
  if (!!window) {
    (window as any)['env'] = {
      ...defaultEnv,
      ...((window as any)['env'] || {}),
    };
  }
  return (window as any)['env'];
}

export const isProd = getEnv().ren_env === 'production';

export default getEnv;
